import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalCommand.CatalogItemRating'

export default defineMessages({
  ratingAriaLabel: {
    id: `${scope}.ratingAriaLabel`,
    defaultMessage:
      '{value} out of {scaleMax} stars from {count, plural, one {# review} other {# reviews}}',
  },
  reviewCount: {
    id: `${scope}.reviewCount`,
    defaultMessage: '({count, number})',
  },
})
